import axios from 'axios';
import { Auth } from 'aws-amplify';
import axiosInstance from './axios';




export async function getAPI(path:any) {
    try {
        const response: any = await axiosInstance.get(path)
        return response
    } catch (e: any) {
        if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' || e.toString() === 'No current user' ){
            try {
                await Auth.signOut();
                window.location.href = '/customerlogin'; // redirect the user to the login page
            } catch (error) {
                console.log('Error signing out: ', error);
            }
        }
        return { error: e.toString() }
    }
}

export async function postAPI(path:any, body:any) {
    try {
        const response: any = await axiosInstance.post(path, body)
        return response
    } catch (e: any) {
        console.log('e', e.toString());
        if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' || e.toString() === 'No current user' ){
            try {
                await Auth.signOut();
                window.location.href = '/customerlogin'; // redirect the user to the login page
            } catch (error) {
                console.log('Error signing out: ', error);
            }
        }
        return { error: e.toString() }
    }
}

export async function putAPI(path:any, body:any) {
    try {
        const response: any = await axiosInstance.put(path, body)
        return response
    } catch (e: any) {
        console.log('e', e.toString());
        if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' || e.toString() === 'No current user' ){
            try {
                await Auth.signOut();
                window.location.href = '/customerlogin'; // redirect the user to the login page
              } catch (error) {
                console.log('Error signing out: ', error);
              }
        }
        return { error: e.toString() }
    }
}

export async function uploadApi(path: any, body: any, type: any){
    try {
        const response: any = await axiosInstance.put(path, body, {
                    headers: {
                        'Content-Type': type
                    }
                })
        return response
    } catch (e: any) {
        console.log('e', e.toString());
        if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' || e.toString() === 'No current user' ){
            try {
                await Auth.signOut();
                window.location.href = '/customerlogin'; // redirect the user to the login page
            } catch (error) {
                console.log('Error signing out: ', error);
            }
        }
        return { error: e.toString() }
    }
}
